import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import emoji from '@/assets/images/sdk-emoji.gif';
import gifs from '@/assets/images/sdk-gifs.gif';
import stickers from '@/assets/images/sdk-stickers.gif';
import text from '@/assets/images/sdk-text.gif';
import giphyText from '@/assets/images/sdk-giphy-text.gif';
import { Clip, ClipsContainer, GIF } from '@/components/common/giphy-media';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
      <h2>{`Content Types`}</h2>
      <p>{`At GIPHY, we believe everything should move and it’s part of our mission to help make everyday conversations more animated. With our growing list of content types, expressing yourself with GIPHY has never been easier.`}</p>
      <p><strong parentName="p">{`Please note that the Clips, Emoji, Text, and GIPHY Text content types are only available through the SDK.`}</strong></p>
      <h3>{`Clips`}</h3>
      <p>{`GIPHY Clips (GIFs with Sound) is our newest format and sits at the intersection of GIFs and Video.
Our Clips Library is built with all of the unforgettable quotes, cultural moments,
reactions and characters that we need to express how we are feeling, what we think and who we are.`}</p>
      <p>{`We are making short form expression discoverable via GIPHY Clips Search,
with Clips from official content partners and GIPHY Studios. Every day you will find new Clips from the biggest names
in Entertainment, Sports, News, and Pop Culture; all trimmed to their most essential moment.`}</p>
      <ClipsContainer mdxType="ClipsContainer">
  <Clip src="https://giphy.com/embed/CA1SY8zmueTnbPj37R/video" height="156px" mdxType="Clip" />
  <Clip src="https://giphy.com/embed/wrXq106ftNYmBKQe6C/video" height="156px" mdxType="Clip" />
  <Clip src="https://giphy.com/embed/jHMLdLrZT2jOAcZh4t/video" height="156px" mdxType="Clip" />
      </ClipsContainer>
      <h3>{`GIFs`}</h3>
      <p>{`GIFs are short, looping, moving images. Need we say more?`}</p>
      <GIF height="120px" src={gifs} mdxType="GIF" />
      <h3>{`Stickers`}</h3>
      <p>{`Stickers are GIFs with transparent backgrounds. They’re great for layering animated content on top of all kinds of use cases: messaging apps, stories (e.g., IG, Snap, FB etc.), or games. Basically, any time a square frame just won't do.`}</p>
      <GIF height="120px" src={stickers} mdxType="GIF" />
      <h3>{`Emoji`}</h3>
      <p>{`GIPHY Emojis are fully animated emoji stickers. No longer are these familiar, emotive faces frozen in place, as GIPHY emoji brings life and motion to some all time favorites, as well as some new (and uniquely GIPHY) emojis.`}</p>
      <GIF height="120px" src={emoji} mdxType="GIF" />
      <h3>{`Text`}</h3>
      <p>{`GIPHY Text features animated text-based stickers, making it easy to add that perfect amount of sarcasm, enthusiasm, or whatever emotion is needed to the conversation.`}</p>
      <GIF height="120px" src={text} mdxType="GIF" />
      <h3>{`GIPHY Text`}</h3>
      <p>{`GIPHY Text is dynamically generated using the user’s search term and our pre-populated set of styles. This content type can be leveraged when you know exactly what you’d like to say and would like to animate your words.`}</p>
      <GIF height="120px" src={giphyText} mdxType="GIF" />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      